// INFO: Bemærk ændringer til denne fil, vil ikke blive inkluderet i den endelige applikation
// Virksomhedsguiden importerer samme stylesheet fra design systemet
import 'dkfds/dist/css/dkfds.min.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store, { useQuickGuideStateStore } from './stores/quickGuideState';

const app = createApp(App);
app.use(store);
app.use(router);

/**
 * Sørg for specifik Pinia fejl ikke vises ved hvert tekstnøgle opslag.
 * Bemærk konsollen vil dog stadig vise denne fejl når den transpileret version af applikationen afvikles, men kun i build mode *
 */
app.config.warnHandler = (msg, _, trace) => {
  if (!['injection "Symbol(pinia)" not found.'].some(warning => msg.includes(warning))) {
    // eslint-disable-next-line no-console
    console.warn('[Vue warn]: '.concat(msg).concat(trace));
  }
};

// Mount the app immediately - content loading will be handled by App.vue
app.mount('#app');
